export class EnumItem {
    constructor(id: number, caption: string, description: string) {
        this.Id = id;
        this.Caption = caption;
        this.Description = description;
    }

    public Caption: string;
    public Description: string;
    public Icon: string;
    public IconColor: string;
    public Id: number;
}


export class Column {
    public ColumnName: string = null;
    public PcId: number = null;
    public DbcId: number = null;
    public Type_FK: number = null;
    public Nullable: boolean = false;
    public VisibleOnGrid: number = 0;
    public IsVisibleOnForm: boolean = false;
    public IsVisibleOnFilter: boolean = false;
    public IsVisibleOnTooltip: boolean = false;
    public LocalizationString: string = null;
    public ComputedExpressionEnabled: boolean = false;
    public CustomFilterEnabled: boolean = false;
    constructor() {
    }
}

export class ValidateCreditCardNumberResult {
    constructor(valid: boolean, ccError: string, cardCompany: string) {
        this.Valid = valid;
        this.CcError = ccError;
        this.CardCompany = cardCompany;
    }

    public Valid: boolean;
    public CcError: string;
    public CardCompany: string;
}

